import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { container } from "tsyringe";
import { useEffect, useMemo, useRef, useState } from "react";
import CarCategories from "./results/carCategories";
import AvailabilityList from "./results/availabilityList";
import { parsePhoneNumber } from 'libphonenumber-js';
import "../assets/saas/pages/availability.scss";
import moment from "moment";
import NoResultsBanner from "./results/loading/noResults";
import { getLandingPageBrand } from "../hooks/LandingPage";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import IconElectricFilter from "../assets/iconElectricFilter";
import IconBasicPlus from "../assets/iconBasicPlus";
import IconAllInclusiveMax from "../assets/iconAllInclusiveMax";
import IconFuelOutline from "../assets/iconFuelOutline";
import * as Sentry from "@sentry/react";
import React from "react";
import { searchTimeout } from "../../infrastructure/utils/withTimeout";
import filterso from "../components/search_bar/filters.json";
import defaultRenters from "./search_bar/defaultRenters";
import { useAppVariableGlobalToWindow } from "../hooks/AppCustomWindow";
import { Engine, GroupRates } from "./../../domain/constants";
import { mergeRentersWithImages } from "./../../infrastructure/utils/mergeRentersWithImages";
import ProfitLoading from "./commons/profitLoading";
import { isTestMarketCountry } from "../../utils/testMarket";
import MapModalLocations from "./commons/mapModalLocations/mapModalLocations";
/**
 * Represents the possible statuses of the application.
 *
 * @enum {number}
 * @property {number} INITIAL - The initial state of the application.
 * @property {number} RUNNIG - The application is currently running.
 */
export var Status_App;
(function (Status_App) {
    Status_App[Status_App["INITIAL"] = 0] = "INITIAL";
    Status_App[Status_App["RUNNIG"] = 1] = "RUNNIG";
})(Status_App || (Status_App = {}));
const SearchResults = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const dataStore = container.resolve("IUseStoreAplication");
    const { getCategories } = container.resolve("iUseCaseGetCategories");
    const _GetExchangeRates = container.resolve("iUseCaseGetExchangeRates");
    const _BookingServices = container.resolve("IBookingServices");
    const _GetCollections = container.resolve("iUseCaseGetCollections");
    const getRenters = container.resolve("iUseCaseGetRenters");
    const getDaysDifference = container.resolve("iUseCaseGetDaysDifferences");
    const generateSearchId = container.resolve("IGenerateSearchId");
    const _GetCategoryConfig = container.resolve("iUseCaseCategoryConfig");
    const _analiFingerprint = container.resolve("iAnalizeFingerprint");
    const banners = container.resolve("iUseCaseGetAllBanners");
    const getIp = container.resolve("iUseCaseGetClientIp");
    const loadingServices = container.resolve("ILoadingServices");
    const { setVariable, getVariable } = useAppVariableGlobalToWindow();
    const generateSessionId = container.resolve("IGenerateSessionId");
    const offersRef = useRef([]);
    const noResultTimeoutRef = useRef(null);
    const { t, i18n } = useTranslation();
    const [filters, setFilters] = useState(() => {
        var _a, _b;
        const defaultFilters = {
            renterFilters: [],
            categoryFilters: [],
            rateFilters: [],
            engineFilters: [],
            PickUpLocationCode: "",
            ReturnLocationCode: "",
        };
        return (_b = JSON.parse((_a = sessionStorage.getItem("filters")) !== null && _a !== void 0 ? _a : JSON.stringify(defaultFilters))) !== null && _b !== void 0 ? _b : defaultFilters;
    });
    const [shouldBeSelectedfilters, setShouldBeSelectedFilters] = useState(sessionStorage.getItem("shouldFilter") === "true" ? JSON.parse(sessionStorage.getItem("filters") || "{}") : {});
    const [resultFiltersrenters, setResultFiltersRenters] = useState([]);
    const [resultFiltersCategories, setResultFiltersCategories] = useState([]);
    //variable token must be extrated from the cookies, the value is called token in the cookies
    const token = ((_a = document.cookie
        .split("; ")
        .find((row) => row.startsWith("token="))) === null || _a === void 0 ? void 0 : _a.split("=")[1]) || "";
    const [carCategories, setCarCategories] = useState([]);
    const [carRenters, setCarRenters] = useState([]);
    const [collections, setCollections] = useState([]);
    const [collectionMock, setCollectionMock] = useState([]);
    const [rate, setRate] = useState(0);
    const [idSession, setidSession] = useState(() => sessionStorage.getItem("guid") || generateSessionId.handle());
    const [transactionId, setTransactionId] = useState("");
    const [userId, setUserId] = useState("");
    const [totalDays, setTotalDays] = useState();
    const [ip, setIp] = useState("");
    const [taxes, setTaxes] = useState(0.18);
    const [pageNumber, setPageNumber] = useState(1);
    const currenType = useRef("initial");
    const currentPage = useRef(1);
    const [data, setData] = useState([]); // or a more specific type if you have one
    const [applyDiscount, setApplyDiscount] = useState(false);
    const [noResultstate, setNoResultState] = useState(false);
    const [noResultstateFilters, setNoResultStateFilters] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userAnalizer, setUserAnalize] = useState(null);
    const [showMoreButton, setShowMoreButton] = useState(false);
    const [statusApp, setStatusApp] = useState(Status_App.INITIAL);
    const [showFilters, setShowFilters] = useState(true);
    const searchParams = new URLSearchParams(window.location.search);
    // create a value called oldcar that must be feed from an url param of the same name
    const oldcar = searchParams.get("oldcar") != null ? searchParams.get("oldcar") : "";
    const [searchId, setSearchId] = useState(sessionStorage.getItem("searchId") || generateSearchId.handle());
    console.log("nuevo archivo");
    const [visibleItems, setVisibleItems] = useState(sessionStorage.getItem("shouldFilter") === "true"
        ? Number(sessionStorage.getItem("itemsNumber")) || Number((_b = process.env.REACT_APP_PAGINATE_RESULTS) !== null && _b !== void 0 ? _b : 5)
        : Number((_c = process.env.REACT_APP_PAGINATE_RESULTS) !== null && _c !== void 0 ? _c : 5));
    const [bannersData, setBannersData] = useState([]);
    const [categoryTranslations, setCategoryTranslations] = useState([]);
    const translationMapRef = useRef(new Map());
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [isCompleted, setIsCompleted] = useState(false);
    // AB#8231 — isFinal comes from the last FilterResult WS message (backend sets it true
    // once the orchestrator is complete AND every provider has responded). It is the
    // deterministic signal for the 4-state render machine in RenderCategoryItems:
    // while false we keep showing the loader pill for price===0 entries, so categories
    // with late-arriving providers do not flash $0 and then disappear.
    const [isFinal, setIsFinal] = useState(false);
    // WI #8534 — `isComplete` is the post-#8421 BE deterministic completion signal
    // (`FilterPagingClientService` emits `isComplete=true` exactly once when the
    // orchestrator AND all paging is genuinely done). Threaded down to
    // `RenderCategoryItems` to gate the Empty-definitive state, which otherwise
    // could collapse pills on a premature `IsFinal=true` frame.
    const [isComplete, setIsComplete] = useState(false);
    // AB#8556 revert — `filterClickBarrier = useFilterClickBarrier()` removed.
    // The barrier was dropping every post-click WS frame because BE does not
    // echo `filter`. See the import-block comment for full context.
    // set the style of the element to display none
    const [extraFilters, setExtraFilters] = useState([
        {
            type: "fuel",
            name: t("electric"),
            icon: _jsx(IconElectricFilter, {}),
            price: 0,
            value: Engine.ELECTRIC,
            selected: false,
        },
        {
            type: "fuel",
            name: t("fuel"),
            icon: _jsx(IconFuelOutline, {}),
            price: 0,
            value: Engine.FUEL,
            selected: false,
        },
        {
            type: "rate",
            name: "Basic Plus",
            icon: _jsx(IconBasicPlus, {}),
            price: 0,
            value: GroupRates.BASIC_PLUS,
            selected: false,
            order: 0,
        },
        {
            type: "rate",
            name: "All Inclusive",
            icon: _jsx(IconAllInclusiveMax, {}),
            price: 0,
            value: GroupRates.ALL_INCLUSIVE_MAX,
            selected: false,
            order: 1,
        },
    ]);
    const app = searchParams.has("app");
    const isValidCurrency = (v) => !!v && /^[A-Z]{3}$/i.test(v.trim());
    const paramCurrency = ((_d = document.cookie
        .split("; ")
        .find((row) => row.startsWith("currencyApp="))) === null || _d === void 0 ? void 0 : _d.split("=")[1]) || searchParams.get("currency");
    const sessionCurrency = sessionStorage.getItem("currency");
    const shopifyCurrency = (_f = (_e = window.Shopify) === null || _e === void 0 ? void 0 : _e.currency) === null || _f === void 0 ? void 0 : _f.active;
    // Sanitize poisoned values (e.g. "COP0") that may persist in sessionStorage
    const safeParam = isValidCurrency(paramCurrency) ? paramCurrency.trim().toUpperCase() : null;
    const safeSession = isValidCurrency(sessionCurrency) ? sessionCurrency.trim().toUpperCase() : null;
    const safeShopify = isValidCurrency(shopifyCurrency) ? shopifyCurrency.trim().toUpperCase() : null;
    const resolvedCurrency = app && safeParam
        ? safeParam
        : safeSession || safeParam || safeShopify || "USD";
    const currency = (resolvedCurrency || "USD").toString().toUpperCase();
    sessionStorage.setItem("currency", currency);
    const cleanParam = (value, fallback = "") => {
        if (value === null)
            return fallback;
        const trimmed = value.trim();
        if (trimmed.toLowerCase() === "undefined" || trimmed.toLowerCase() === "null")
            return fallback;
        return trimmed;
    };
    const pickUpDate = cleanParam(searchParams.get("pickUpDate"));
    const DropOffDate = cleanParam(searchParams.get("returnDate"));
    const pickUpTime = cleanParam(searchParams.get("pickUpTime"), "10:00");
    const DropOffTime = cleanParam(searchParams.get("returnTime"), "10:00");
    const landingid = cleanParam(searchParams.get("landingId")) || undefined;
    const pickPlaceId = cleanParam(searchParams.get("pickPlaceId"));
    const pickDataSource = cleanParam(searchParams.get("pickDataSource"));
    const dropPlaceId = cleanParam(searchParams.get("dropPlaceId"));
    const dropDataSource = cleanParam(searchParams.get("dropDataSource"));
    const pickupLocationCode = cleanParam(searchParams.get("pickuplocation"));
    const returnLocationCode = cleanParam(searchParams.get("returnlocation"));
    const extractCountryFromCode = (code) => {
        const match = code.match(/^([A-Z]{2})-/);
        return match ? match[1] : "";
    };
    const [locationsResults, setLocationsResults] = useState();
    const pickCountry = cleanParam((_g = searchParams.get("pickCountry")) !== null && _g !== void 0 ? _g : sessionStorage.getItem("pickCountry"))
        || extractCountryFromCode(pickupLocationCode);
    const returnCountry = cleanParam((_h = searchParams.get("dropCountry")) !== null && _h !== void 0 ? _h : sessionStorage.getItem("dropCountry"))
        || extractCountryFromCode(returnLocationCode);
    const keyLocalStorageResultFilters = `ResultFilters`;
    const [finalized, setFinalized] = useState(false);
    const [userUFP, setUserUFP] = useState(sessionStorage.getItem("userFP"));
    useEffect(() => {
        searchTimeout.start("getFilters", searchId);
        const registryPromise = _BookingServices.getFilters((data) => {
            searchTimeout.resolve("getFilters", searchId);
            processFilters(data);
        });
        return () => {
            searchTimeout.cancel("getFilters");
            registryPromise.then((r) => r.unregister()).catch(() => { });
        };
    }, [collectionMock]);
    useEffect(() => {
        var _a, _b, _c;
        // AB#8269 — Currency-change remount detection.
        // When the user switches currency on `/collections/all`, the page reloads
        // and `SearchResults` remounts. Without this guard, the component reuses
        // the cached `sessionStorage.searchId` and the previous `isFinal=true`
        // state can be re-applied against still-empty/zero-priced categories,
        // collapsing the pills (the bug reported in WI #8269). On a confirmed
        // currency change we (a) drop the cached `searchId` so a fresh search is
        // emitted and (b) reset `isFinal` to `false` so the 3-state render
        // machine in `RenderCategoryItems` keeps showing loaders until the new
        // priced FilterResult arrives. The 30s `forcedFinal` safety net in
        // `categoryCard.tsx` (Bug #8051) and the WI #7947 currency-mismatch
        // discard guard in `processFilters` are unaffected.
        const remountSearchParams = new URLSearchParams(window.location.search);
        const currentCurrency = ((_c = (_b = (_a = remountSearchParams.get("currency")) !== null && _a !== void 0 ? _a : remountSearchParams.get("cy")) !== null && _b !== void 0 ? _b : sessionStorage.getItem("currency")) !== null && _c !== void 0 ? _c : "USD").toString().toUpperCase();
        const lastSearchedCurrency = sessionStorage.getItem("currency-lastSearch");
        if (lastSearchedCurrency && lastSearchedCurrency !== currentCurrency) {
            // Real currency-change remount — invalidate cached searchId and reset isFinal.
            sessionStorage.removeItem("searchId");
            setIsFinal(false);
        }
        // Persist the current currency so the next mount can detect the next change.
        sessionStorage.setItem("currency-lastSearch", currentCurrency);
        if (sessionStorage.getItem("searchId") == null || sessionStorage.getItem("searchId") == "") {
            sessionStorage.setItem("searchId", generateSearchId.handle());
        }
        processFilters(filterso);
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual"; // Disable automatic scroll restoration
        }
        // Ensure the page starts at the top
        window.scrollTo(0, 0);
        // Optional cleanup (restore default behavior when leaving the page)
    }, []);
    useEffect(() => {
        if (showFilters) {
            sessionStorage.setItem("shouldFilter", "false");
        }
    }, [showFilters]);
    // WI #8432 — Mobile browsers' native Share menu reads
    // <link rel="canonical"> and <meta property="og:url"> before falling back
    // to the address-bar URL. Shopify SSR emits both tags with a clean URL
    // (no query string), so a search results page shared via WhatsApp lost
    // every param. Patch both tags client-side with the current full URL so
    // the native Share menu sees every search param.
    // Only run on Shopify product or collection pages — never patch the tags
    // on other surfaces where the bundle may incidentally mount.
    useEffect(() => {
        const pathname = window.location.pathname;
        const isProductOrCollectionPage = pathname.includes("/products") || pathname.includes("/collections");
        if (!isProductOrCollectionPage)
            return;
        const fullUrl = window.location.href;
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", fullUrl);
        let ogUrl = document.querySelector('meta[property="og:url"]');
        if (!ogUrl) {
            ogUrl = document.createElement("meta");
            ogUrl.setAttribute("property", "og:url");
            document.head.appendChild(ogUrl);
        }
        ogUrl.setAttribute("content", fullUrl);
    }, []);
    useEffect(() => {
        var _a, _b;
        console.log("[SearchResults] mount");
        const locationsRegistryPromise = _BookingServices.getLocationsResults((data) => {
            setLocationsResults(data);
        });
        // Redirect disabled for debugging UK/locale flow.
        // if (window.location.pathname === "/undefined-null/collections/all") {
        //   let oldUrl = window.location.href;
        //   let params = oldUrl.split("?")[1];
        //   let newUrl = `${window.location.origin}/collections/all?${params}`;
        //   window.location.href = newUrl;
        // }
        // Combine currency and locale corrections into a single redirect to avoid double reload
        const normalizeParam = (value) => (value && value.trim() ? value.trim() : "");
        const currencyFromSession = normalizeParam(sessionStorage.getItem("currency"));
        const shopifyCurrencyVal = normalizeParam((_b = (_a = window === null || window === void 0 ? void 0 : window.Shopify) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.active);
        const currencyParam = currencyFromSession || shopifyCurrencyVal || "USD";
        const currentSearchParams = new URLSearchParams(window.location.search);
        let needsRedirect = false;
        // Check 1: Ensure currency param matches resolved currency
        if (!currentSearchParams.has("currency") || currentSearchParams.get("currency") !== currencyParam) {
            currentSearchParams.set("currency", currencyParam);
            needsRedirect = true;
        }
        // Check 2: Ensure correct locale prefix in path
        let targetPathname = window.location.pathname;
        if (!searchParams.has("app")) {
            const rawPathname = window.location.pathname;
            const pathname = rawPathname.toLowerCase();
            const pathSegment = pathname.split("/")[1] || "";
            const sessionLocale = (sessionStorage.getItem("locale") || "").toLowerCase();
            const supportedDialects = ["es-es", "en-uk", "en-gb"];
            const getBaseLocale = (rawLocale) => rawLocale.slice(0, 2);
            const resolveLocale = () => {
                const candidate = pathSegment && !["collections", "pages"].includes(pathSegment) ? pathSegment : sessionLocale;
                if (candidate === "en")
                    return "";
                if (supportedDialects.includes(candidate))
                    return `/${candidate}`;
                const baseLocale = getBaseLocale(candidate);
                if (baseLocale && baseLocale !== "en")
                    return `/${baseLocale}`;
                return "";
            };
            const locale = resolveLocale();
            const resolvedTargetPath = `${locale}/collections/all`.replace(/\/{2,}/g, "/").replace(/\/$/, "");
            const currentPath = rawPathname.replace(/\/$/, "");
            if (/\/collections\/all$/i.test(currentPath) && currentPath.toLowerCase() !== resolvedTargetPath) {
                targetPathname = resolvedTargetPath;
                needsRedirect = true;
            }
        }
        // Redirect disabled for debugging UK/locale flow.
        // if (needsRedirect) {
        //   const query = currentSearchParams.toString();
        //   const redirectUrl = `${window.location.origin}${targetPathname}${query ? `?${query}` : ""}${window.location.hash}`;
        //   window.location.href = redirectUrl;
        //   return;
        // }
        const documentBody = document.body;
        documentBody.classList.add("loading");
        const tasksRegistryPromise = _BookingServices.validateTasksComplete((data) => {
            if (data.isCompleted) {
                documentBody.classList.remove("loaxding");
                setFinalized(true);
                if (offersRef.current.length === 0) {
                }
            }
        });
        return () => {
            console.log("[SearchResults] unmount");
            locationsRegistryPromise.then((r) => r.unregister()).catch(() => { });
            tasksRegistryPromise.then((r) => r.unregister()).catch(() => { });
        };
    }, []);
    function formatDateToDdMmYyyy(inputDate) {
        return moment(inputDate).format("YYYY-MM-DD").toString();
    }
    const visitorId = userUFP !== null && userUFP !== void 0 ? userUFP : sessionStorage.getItem("userFP");
    const userCountry = sessionStorage.getItem("country") || pickCountry || returnCountry || "US";
    const isTestMarket = isTestMarketCountry(userCountry);
    const market = sessionStorage.getItem("market") || "us";
    const formattedPickUpDate = `${formatDateToDdMmYyyy(pickUpDate === null || pickUpDate === void 0 ? void 0 : pickUpDate.toString())}T${pickUpTime}:00`;
    const formattedDropOffDate = `${formatDateToDdMmYyyy(DropOffDate === null || DropOffDate === void 0 ? void 0 : DropOffDate.toString())}T${DropOffTime}:00`;
    const pickUpLocationName = cleanParam(sessionStorage.getItem("pickupLocation")) || cleanParam(searchParams.get("pickupLocName"));
    const returnLocationName = cleanParam(sessionStorage.getItem("returnLocation")) || cleanParam(searchParams.get("returnLocName")) || pickUpLocationName;
    const { nationalityDrivingLicense } = dataStore.quicksearch.data;
    const initialGeolocationData = useMemo(() => isTestMarket
        ? [
            {
                locationType: "PickUp",
                dataSource: pickDataSource,
                placeId: pickPlaceId,
                latitude: 0,
                longitude: 0,
                countryCode: pickCountry,
            },
            {
                locationType: "Return",
                dataSource: dropDataSource,
                placeId: dropPlaceId,
                latitude: 0,
                longitude: 0,
                countryCode: returnCountry,
            },
        ]
        : [], [isTestMarket, pickDataSource, pickPlaceId, dropDataSource, dropPlaceId, pickCountry, returnCountry]);
    const [geolocationData, setGeolocationData] = useState(initialGeolocationData);
    useEffect(() => {
        setGeolocationData(initialGeolocationData);
    }, [initialGeolocationData]);
    const payload = useMemo(() => ({
        userId: "1",
        nationalityDrivingLicense: nationalityDrivingLicense,
        pickUpDateTime: formattedPickUpDate,
        returnDateTime: formattedDropOffDate,
        userCountry: userCountry,
        device: navigator.userAgent,
        pickUpLocation: isTestMarket ? {} : {
            locationCode: pickupLocationCode,
            codeContext: "IATA",
            locationName: pickUpLocationName,
            locationCountry: pickCountry,
        },
        returnLocation: isTestMarket ? {} : {
            locationCode: returnLocationCode,
            codeContext: "IATA",
            locationName: returnLocationName,
            locationCountry: returnCountry ? returnCountry : pickCountry,
        },
        brand: getLandingPageBrand(),
        searchId: searchId,
        language: i18n.language.toUpperCase(),
        market: market,
        paging: {
            pageNumber: pageNumber,
            pageSize: 30,
        },
        filter: {
            renters: filters.renterFilters,
            typesCar: filters.categoryFilters,
            fuelTypes: filters.engineFilters,
            groupRates: filters.rateFilters,
            PickUpLocationCode: filters.PickUpLocationCode,
            ReturnLocationCode: filters.ReturnLocationCode,
        },
        idSession: sessionStorage.getItem("idSession") || idSession,
        visitorId: visitorId,
        sort: {
            name: sortBy,
            order: sortOrder,
        },
        tokenApp: token,
        oldCar: oldcar === null || oldcar === void 0 ? void 0 : oldcar.toString(),
        currency: currency,
        urlSearch: window.location.href,
    }), [
        formattedPickUpDate,
        pickUpTime,
        formattedDropOffDate,
        DropOffTime,
        userCountry,
        pickupLocationCode,
        returnLocationCode,
        pickUpLocationName,
        returnLocationName,
        isTestMarket,
        i18n.language,
        pageNumber,
        idSession,
        visitorId,
        sortBy,
        sortOrder,
        filters,
        nationalityDrivingLicense,
        searchId,
        oldcar
    ]);
    let actualResults = 0;
    /**
     * Fetches data based on the provided parameters and updates the state accordingly.
     * @param page number current page number
     * @param size number number of items per page
     * @param ipBase string optional base IP address to use for the request
     * @param type string optional type of request, can be "initial", "filter", or "paginate"
     */
    const getData = (page, size, ipBase, type) => {
        if (payload.searchId == null || payload.searchId == "") {
            payload.searchId = sessionStorage.getItem("searchId") || generateSearchId.handle();
        }
        sessionStorage.setItem("pageNumber", page.toString());
        setShowMoreButton(false);
        setVariable("FilterToLastGetData", JSON.stringify(payload.filter));
        const updatedPayload = {
            ...payload,
            paging: {
                ...payload.paging,
                pageNumber: page,
                pageSize: size,
            },
        };
        // Reset any pending timeout before scheduling a new one
        if (dataRefToCallback.current.timer !== null)
            clearTimeout(dataRefToCallback.current.timer);
        // Only track timeouts for initial searches — filter/paginate use cached data
        // and produce false-positive 20s timeouts when a category has 0 offers (AB#8068 gate suppresses empty SearchResults).
        if (type === "initial") {
            searchTimeout.start("availability", searchId);
        }
        setStatusApp(Status_App.RUNNIG); // Set statusApp to RUNNIG after the first search is done
        let eventToEmitAvailability = statusApp === Status_App.INITIAL ? _BookingServices.emitAvailability : _BookingServices.emitAvailabilityByFilter;
        if (type === "paginate")
            eventToEmitAvailability = _BookingServices.emitAvailability; // overwrite fetchMethod for pagination
        eventToEmitAvailability(updatedPayload, type !== "initial", userUFP != null ? userUFP : sessionStorage.getItem("userFP"), oldcar === null || oldcar === void 0 ? void 0 : oldcar.toString(), geolocationData);
    };
    const dataRefToCallback = useRef({
        data: null,
        timer: null,
    });
    // WI #7947 follow-up — When the currency-mismatch guards in `onAvailability`
    // and `processFilters` drop every WS snapshot after a currency switch, the
    // per-category `loadingData: true` state never flips to `false`, so the
    // green progress bar inside `.category-loader` keeps animating forever
    // (reported in Safari, Edge, Chrome and Atlas). Arming this timer on drop
    // gives the backend a bounded window to deliver a matching-currency payload;
    // if it never arrives we clear the pending loaders explicitly. The timer is
    // idempotent (already-armed calls are no-ops) and is cancelled the moment a
    // matching snapshot is accepted.
    const currencyMismatchFallbackRef = useRef(null);
    const CURRENCY_MISMATCH_FALLBACK_MS = 4000;
    const clearCurrencyMismatchFallback = () => {
        if (currencyMismatchFallbackRef.current !== null) {
            clearTimeout(currencyMismatchFallbackRef.current);
            currencyMismatchFallbackRef.current = null;
        }
    };
    const armCurrencyMismatchFallback = (reason) => {
        if (currencyMismatchFallbackRef.current !== null)
            return;
        currencyMismatchFallbackRef.current = setTimeout(() => {
            currencyMismatchFallbackRef.current = null;
            Sentry.captureMessage(`WI#7947 fallback: no matching-currency snapshot after ${CURRENCY_MISMATCH_FALLBACK_MS}ms (${reason}); clearing loaders`, "warning");
            setLoading(false);
            setResultFilters((prev) => ({
                ...prev,
                categories: prev.categories.map((car) => car.loadingData === true ? { ...car, loadingData: false } : car),
                renters: prev.renters.map((renter) => renter.loadingData === true ? { ...renter, loadingData: false } : renter),
            }));
        }, CURRENCY_MISMATCH_FALLBACK_MS);
    };
    /**
     * Processes the filters data and updates the state accordingly.
     * @param data - The filters data to process.
     */
    useEffect(() => {
        dataRefToCallback.current.data = data;
    }, [data]);
    useEffect(() => {
        return () => {
            if (dataRefToCallback.current.timer !== null)
                clearTimeout(dataRefToCallback.current.timer);
            if (noResultTimeoutRef.current !== null) {
                clearTimeout(noResultTimeoutRef.current);
                noResultTimeoutRef.current = null;
            }
            clearCurrencyMismatchFallback();
        };
    }, []);
    /**
     * Sets up an event listener for availability updates and processes the data when received.
     * This function is called when the component mounts and sets up the listener.
     */
    useEffect(() => {
        // initialize actions component
        // Set up the event listener for availability updates
        const availabilityRegistryPromise = _BookingServices.onAvailability((offersData) => {
            var _a;
            // WI #7947 — Drop any car-listing snapshot whose Currency does not match
            // the currently active UI currency. Same rationale as the guard inside
            // processFilters: after a currency switch the WS can deliver an in-flight
            // payload from the prior cycle (prices computed in the OLD currency)
            // before the fresh one arrives — rendering those numbers with the NEW
            // symbol produces the Safari/Atlas incognito bug reported in WI 7947.
            // SearchResultsDto already carries `currency` (PagingClientServices.cs),
            // so we just read it and drop mismatches. Legacy payloads without a
            // `currency` field fall through and are accepted as before.
            const eventCurrency = typeof (offersData === null || offersData === void 0 ? void 0 : offersData.currency) === "string"
                ? offersData.currency.toUpperCase()
                : undefined;
            if (eventCurrency && currency && eventCurrency !== currency.toUpperCase()) {
                armCurrencyMismatchFallback("onAvailability");
                return;
            }
            clearCurrencyMismatchFallback();
            // AB#8556 revert — the click-cut barrier guard that lived here was
            // unwired. It was dropping every post-click frame because the BE
            // does not echo `filter` on `SearchResultsPaging`, leaving the
            // cards list in an infinite loader. See the import-block comment
            // for full context and the path back to re-wiring.
            const page = ((_a = offersData.paging) === null || _a === void 0 ? void 0 : _a.pageNumber) || 1;
            // Clear timeout if data is received
            if (dataRefToCallback.current.timer !== null)
                clearTimeout(dataRefToCallback.current.timer);
            searchTimeout.resolve("availability", searchId);
            if (offersData.results && offersData.results.offers.length > 0) {
                setLoading(false);
                setDataCounter((prev) => prev + 1);
                proccessData(offersData, page);
            }
            else {
                Sentry.captureMessage("No offers found!", "warning"); // Log instead of throwing an error
                // When a filter request returns zero results, show the filter-specific "no results" banner
                if (currenType.current === "filter") {
                    setNoResultStateFilters(true);
                }
                setLoading(false);
            }
        });
        return () => {
            availabilityRegistryPromise.then((r) => r.unregister()).catch(() => { });
        };
    }, []);
    const [dataCounter, setDataCounter] = useState(0);
    function separarNumero(numeroCompleto) {
        try {
            const phoneNumber = parsePhoneNumber(numeroCompleto);
            return {
                codigoPais: `+${phoneNumber.countryCallingCode}`,
                numeroCelular: phoneNumber.nationalNumber,
            };
        }
        catch (error) {
            return { codigoPais: '', numeroCelular: numeroCompleto }; // número inválido
        }
    }
    /**
     * Processes the received offers data and updates the state accordingly.
     * @param {OffersData} offersData - The data received from the availability service.
     * @param {number} page - The current page number.
     * @returns
     */
    const proccessData = (offersData, page) => {
        const data = dataRefToCallback.current.data || [];
        if (!offersData)
            return;
        let currentData = data;
        if (page === 1)
            currentData = []; // Reset currentData if it's the first page
        setidSession(offersData.idSession);
        setTransactionId(offersData.transactionId);
        if (offersData.results) {
            if (offersData.isCompleted == true) {
                setIsCompleted(true);
            }
            actualResults++;
            if (offersData.userAnalyzer) {
                setUserAnalize(offersData.userAnalyzer);
                if (offersData.userAnalyzer.applyDiscount !== undefined) {
                    sessionStorage.setItem("applyDiscount", offersData.userAnalyzer.applyDiscount.toString());
                    setApplyDiscount(offersData.userAnalyzer.applyDiscount);
                }
            }
            //take one totalRentDays inside the offersData.results.offers array and set it to totalDays
            if (offersData.results.offers.length > 0) {
                setTotalDays(offersData.results.offers[0].totalRentDays);
                if (geolocationData.length > 0) {
                    setGeolocationData((prev) => {
                        if (prev.length < 2)
                            return prev;
                        const updated = [...prev];
                        const pickUpLocation = offersData.results.offers[0].pickUpLocation;
                        const returnLocation = offersData.results.offers[0].returnLocation;
                        if (pickUpLocation) {
                            updated[0] = {
                                ...updated[0],
                                latitude: pickUpLocation.latitude,
                                longitude: pickUpLocation.longitude,
                            };
                        }
                        if (returnLocation) {
                            updated[1] = {
                                ...updated[1],
                                latitude: returnLocation.latitude,
                                longitude: returnLocation.longitude,
                            };
                        }
                        return updated;
                    });
                }
            }
            if (offersData.enrichedData && offersData.enrichedData != null) {
                sessionStorage.setItem("email", offersData.enrichedData.email || "");
                sessionStorage.setItem("name", offersData.enrichedData.fullName || "");
                const { codigoPais, numeroCelular } = separarNumero(offersData.enrichedData.phoneNumber || "");
                sessionStorage.setItem("phone", numeroCelular || "");
                sessionStorage.setItem("phoneCode", codigoPais || "");
            }
            const befoteData = [...currentData, ...offersData.results.offers];
            const uniqueData = Array.from(new Map(befoteData.map((item) => [item.id, item])).values());
            setData(uniqueData);
            //remove from all elements of id collapsibleFAQS the display none
            setShowMoreButton(page < offersData.paging.totalPages);
        }
        if (offersData.searchId !== undefined) {
            setUserId(offersData.searchId);
            setSearchId(offersData.searchId);
            sessionStorage.setItem("searchId", offersData.searchId);
        }
    };
    let fisrtSearchCounter = 0;
    useEffect(() => {
        if (fisrtSearchCounter === 0) {
            const fetchData = async () => {
                const [categories, bannersData, totalDays, exchangeRate, collectionsData, ipData, categoryConfig, renters] = await Promise.all([
                    getCategories(),
                    banners.handle(),
                    getDaysDifference.handle(pickUpDate || "", DropOffDate || ""),
                    _GetExchangeRates.getExchangeRates(currency || ""),
                    _GetCollections.handle(),
                    getIp.handle(),
                    _GetCategoryConfig.getCategoryConfig(),
                    getRenters.handle(),
                ]);
                setCarCategories(categories);
                setCarRenters(renters);
                setBannersData(bannersData || []);
                setRate(parseFloat(exchangeRate.rates[currency || ""]));
                setCollectionMock(collectionsData);
                setCollections(collectionsData);
                setCategoryTranslations(categoryConfig);
                const map = new Map();
                categoryConfig.forEach((t) => map.set(t.category, t));
                translationMapRef.current = map;
                const resolvedIp = (ipData === null || ipData === void 0 ? void 0 : ipData.ip) || sessionStorage.getItem("ip") || "";
                setIp(resolvedIp);
                if (resolvedIp) {
                    sessionStorage.setItem("ip", resolvedIp);
                }
                getData(pageNumber, 30, resolvedIp, "initial");
                _analiFingerprint.handle({
                    fingerprint: userUFP != null ? userUFP : sessionStorage.getItem("userFP"),
                    ip: resolvedIp,
                });
                setTimeout(() => {
                    loadingServices.EmitLoadingShow(true);
                }, 500);
                noResultTimeoutRef.current = setTimeout(() => {
                    if (offersRef.current.length === 0 && resultFiltersrenters.length === 0 && resultFiltersCategories.length === 0) {
                        setNoResultState(true);
                        loadingServices.EmitLoadingShow(false);
                    }
                }, 30000);
            };
            fetchData();
            fisrtSearchCounter++;
        }
    }, []);
    useEffect(() => {
        sessionStorage.setItem("itemsNumber", data.length.toString());
        if (data.length > 0 && noResultstate) {
            setNoResultState(false);
        }
        offersRef.current = data;
    }, [data, noResultstate]);
    const hasRun = useRef(false); // asegura que getData corra solo 1 vez por ciclo
    const cycleActive = useRef(false);
    useEffect(() => {
        if (statusApp === Status_App.RUNNIG) {
            // Clear the 30s no-result timeout to prevent false "no locations open" banner
            if (noResultTimeoutRef.current) {
                clearTimeout(noResultTimeoutRef.current);
                noResultTimeoutRef.current = null;
            }
            cycleActive.current = false;
            if (dataCounter == 0) {
                cycleActive.current = true;
            } // activa el ciclo
            hasRun.current = false;
            setPageNumber(1);
            currentPage.current = 1;
            currenType.current = "filter";
            setLoading(true);
            sessionStorage.setItem("shouldFilter", "false");
            document.body.classList.add("loading");
            setShouldBeSelectedFilters([]);
            window.scrollTo({ top: 0, behavior: "smooth" });
            setNoResultState(false);
            setNoResultStateFilters(false);
            setData([]);
            getData(1, 30, ip, "filter");
        }
    }, [filters, sortOrder, sortBy]);
    useEffect(() => {
        if (cycleActive.current && // ✅ solo si el primer efecto lo activó
            !loading &&
            statusApp === Status_App.RUNNIG &&
            !hasRun.current) {
            const warmupTimer = setTimeout(() => {
                hasRun.current = true; // se asegura de correr solo una vez
                getData(1, 30, ip, "filter");
            }, 100);
            return () => clearTimeout(warmupTimer);
        }
    }, [loading, statusApp, ip]);
    useEffect(() => {
        const parentElement = document.getElementById('app-results');
        if (parentElement) {
            if (noResultstate || noResultstateFilters) {
                parentElement.classList.add('no-results-found');
            }
            else {
                parentElement.classList.remove('no-results-found');
            }
        }
    }, [noResultstate, noResultstateFilters]);
    /**
     * Processes the renters data by matching each renter with a corresponding collection and updating its properties.
     *
     * @param renters - List of renters to be processed.
     * @returns A clone of filtered renters with updated properties.
     */
    const processFiltersRenters = (renters) => {
        const resultFiltersrentersClone = [];
        renters === null || renters === void 0 ? void 0 : renters.forEach((renter) => {
            var _a;
            if (!renter.value)
                return;
            const matchingCollection = collectionMock.find((collection) => collection.handle.toLowerCase() === renter.name.toLowerCase());
            if (matchingCollection) {
                matchingCollection.price = renter.price;
                matchingCollection.value = renter.value;
                // AB#8070: backend is authoritative for `loadingData`; always propagate it.
                // The previous guard `if (matchingCollection.loadingData == false || ... == "false")`
                // only allowed the update when the current value was already false/"false" — but
                // the initial state seeds loadingData=true, so the guard never fired and
                // `loadingData` stayed stuck at `true` forever, keeping the loader bar animating.
                matchingCollection.loadingData = renter.loadingData;
                // If shouldBeSelectedfilters contains the renter.value, set the matchingCollection.selected to true
                if (shouldBeSelectedfilters.renterFilters &&
                    shouldBeSelectedfilters.renterFilters.includes(renter.value) &&
                    sessionStorage.getItem("shouldFilter") == "true") {
                    matchingCollection.selected = true;
                }
                const existingRenterIndex = resultFiltersrentersClone.findIndex((x) => x.handle === matchingCollection.handle);
                if (existingRenterIndex === -1) {
                    matchingCollection.loadingData = renter.loadingData;
                    resultFiltersrentersClone.push(matchingCollection);
                }
                else {
                    resultFiltersrentersClone[existingRenterIndex].price = renter.price;
                    resultFiltersrentersClone[existingRenterIndex].loadingData = renter.loadingData;
                }
            }
            else {
                // Renter has no matching collection — use defaultRenters as fallback
                // so the renter stays visible in the filter bar instead of disappearing
                const fallback = defaultRenters.find((d) => d.value === renter.value);
                if (fallback) {
                    const existing = resultFiltersrentersClone.findIndex((x) => x.value === renter.value);
                    if (existing === -1) {
                        resultFiltersrentersClone.push({
                            ...fallback,
                            name: renter.name || fallback.title,
                            quantity: renter.quantity || 0,
                            price: renter.price,
                            loadingData: renter.loadingData,
                            image: renter.image || ((_a = fallback.image) === null || _a === void 0 ? void 0 : _a.src) || fallback.image,
                        });
                    }
                }
            }
        });
        return resultFiltersrentersClone;
    };
    /**
     * Processes additional filters (like rates and engines) by matching each filter with a corresponding value.
     *
     * @param extraFilters - List of extra filters (rates, engines) to be processed.
     * @returns A list of processed extra filters with updated properties.
     */
    const proccessExtraFilters = (dataExtraFilters) => {
        const resultExtraFilters = [];
        dataExtraFilters.forEach((data) => {
            if (!data.value)
                return;
            const matchingRateIndex = extraFilters.find((category) => category.value.toLowerCase() === data.value.toLowerCase());
            if (matchingRateIndex) {
                const rateIndex = resultExtraFilters.findIndex((category) => category.value.toLowerCase() === data.value.toLowerCase());
                const matchingRate = { ...matchingRateIndex };
                matchingRate.price = data.price;
                // AB#8070: same guard as in processFiltersRenters — always propagate the
                // backend's authoritative loadingData instead of sticky-true-forever.
                matchingRate.loadingData = data.loadingData;
                // If shouldBeSelectedfilters contains the rate.value, set the matchingRate.selected to true
                if ((shouldBeSelectedfilters === null || shouldBeSelectedfilters === void 0 ? void 0 : shouldBeSelectedfilters.rateFilters) && shouldBeSelectedfilters.rateFilters.includes(data.value)) {
                    matchingRate.selected = true;
                }
                if (shouldBeSelectedfilters.engineFilters && shouldBeSelectedfilters.engineFilters.includes(data.value)) {
                    matchingRate.selected = true;
                }
                if (rateIndex === -1) {
                    resultExtraFilters.push(matchingRate);
                }
                else {
                    const foundRate = resultExtraFilters.find((category) => category.value.toLowerCase() === matchingRate.value.toLowerCase());
                    if (foundRate)
                        foundRate.price = matchingRate.price;
                }
            }
        });
        return resultExtraFilters;
    };
    /**
     * Updates the minimum price based on the allPrices array.
     *
     * @param allPrices - Array of all prices to be compared.
     */
    const updateMinimumPrice = (allPrices) => {
        var _a;
        const minPrice = Math.min(...allPrices);
        const currentMinPrice = parseFloat((_a = sessionStorage.getItem("minimunPrice")) !== null && _a !== void 0 ? _a : "0");
        if (statusApp === Status_App.RUNNIG) {
            if (minPrice < currentMinPrice) {
                sessionStorage.setItem("minimunPrice", minPrice.toString());
            }
        }
        else {
            sessionStorage.setItem("minimunPrice", minPrice.toString());
        }
    };
    /**
     * Main function to process the filters data, including renters, cars, rates, and engines.
     * It updates the local storage and session storage with the filtered results.
     *
     * @param filtersWS - The filters data to be processed.
     */
    const processFilters = (filtersWS) => {
        if (!filtersWS)
            return;
        // AB#8555 follow-up (2026-05-13) — 2-step deserialization of the
        // EventRequestDto envelope. The Gateway forwards Kafka frames from the
        // BookingEngine `availability.filter` topic wrapped in an EventRequestDto
        // (see hola-workflow/references → "EventRequestDto Deserialization"); the
        // actual FilterResultDto is serialized as a JSON STRING inside the
        // envelope's `.data` field. When the envelope is left wrapped:
        //   * `filtersWS.renters` / `.cars` / `.rates` / `.engines` are all
        //     `undefined` — destructuring defaults all four to `[]`
        //   * `filtersWS.isFinal` / `.isComplete` / `.currency` are also undefined
        //   * the WI #8534 `isEmptyHeartbeat` guard below then matches EVERY
        //     frame (real + heartbeat) — `setResultFilters` is never called,
        //     `resultFilters` stays at its empty initial state, and
        //     `Object.values(resultFilters).flat().length > 0` is false, so
        //     `CarCategories` never mounts and `.sticky-bar` is absent from the
        //     DOM. The filter bar literally does not exist (visible incognito,
        //     stale-cache otherwise).
        // Stage 2026-05-13 evidence: searchId 6a0438e84019255a1989ab00 / session
        // 28f0a6d6-a91c-46fb-02e2-8115ee7e6216 — all 7 captured WS filter frames
        // carried the envelope wrapper (the 269-byte vs 448-byte size split
        // observed earlier was the difference between the inner data and the
        // wrapped frame). The unwrap below is defensive: if the payload is
        // already a flat FilterResultDto (legacy / Gateway changes), it falls
        // through unchanged.
        let payload = filtersWS;
        if (typeof filtersWS === "object" &&
            typeof filtersWS.data === "string" &&
            typeof filtersWS.event === "string" &&
            filtersWS.event.endsWith("availability.filter")) {
            try {
                payload = JSON.parse(filtersWS.data);
            }
            catch (_a) {
                return; // malformed envelope — drop frame
            }
        }
        // WI #7947 — Drop any filter snapshot whose Currency does not match the
        // currency currently active in the UI. The backend (FilterAvailabilityService)
        // now stamps the DTO with the currency it used to compute every Price. A
        // mismatch here means the payload was produced for a prior search (the
        // WebSocket delivers the cached snapshot first after reconnect). Rendering
        // those prices with the new currency's symbol is exactly the bug the user
        // reports in Safari/Atlas/incognito when the rapid-switch race fires and the
        // fresh payload never arrives. Legacy payloads without a `currency` field
        // (older backend bundle) fall through and are accepted as before.
        const eventCurrency = typeof payload.currency === "string"
            ? payload.currency.toUpperCase()
            : undefined;
        if (eventCurrency && currency && eventCurrency !== currency.toUpperCase()) {
            armCurrencyMismatchFallback("processFilters");
            return;
        }
        clearCurrencyMismatchFallback();
        const { renters = [], cars = [], rates = [], engines = [] } = payload;
        // AB#8231 / AB#8269 — propagate the backend's final marker. Default false so
        // older payloads (pre-Tier 2 deploy) keep the pre-existing "wait for the
        // safety timer" behavior instead of prematurely collapsing empty pills.
        //
        // AB#8269 gate: only flip `isFinal` to true if at least one car has a
        // non-zero price. The producer-side bug surfaced an "all zero + isFinal=true"
        // race after currency switch — adopting that signal would collapse every
        // pill via `RenderCategoryItems`'s `isEmptyFinal` short-circuit. While the
        // Tier 1 BookingEngine fix is the primary, this client-side gate prevents
        // the collapse if any future producer regression re-introduces the race.
        // The 30s `forcedFinal` safety net in `categoryCard.tsx` still flips state
        // 3 if no priced result ever arrives.
        if (payload.isFinal === true) {
            const hasAnyPricedCar = cars.some((c) => { var _a; return ((_a = c === null || c === void 0 ? void 0 : c.price) !== null && _a !== void 0 ? _a : 0) > 0; });
            if (hasAnyPricedCar) {
                setIsFinal(true);
            }
        }
        // WI #8534 — `isComplete` is the post-#8421 BE deterministic completion
        // signal (`FilterPagingClientService` emits it exactly once when the
        // orchestrator AND all paging is genuinely done). Parallel to `isFinal`,
        // never replaces it. Defaults to `false`; legacy payloads without the
        // field simply never flip it — the 30s `forcedFinal` safety net in
        // `categoryCard.tsx` still guarantees state 3 collapses eventually.
        if (payload.isComplete === true) {
            setIsComplete(true);
        }
        // WI #8534 follow-up — Drop BE heartbeat/keepalive frames that carry
        // empty arrays for ALL 4 filter axes (renters, cars, rates, engines).
        // Observed in stage 2026-05-12 with searchId=6a0357c04019255a19802aad:
        // between real filter snapshots the BE emits frames shaped
        // `{ rates: [], engines: [], cars: [], renters: [], isFinal: false }`
        // at T+3s, T+6s, T+9s, T+12s. Without this guard the FE renders each
        // empty payload, blanking out the filter bar a few seconds into the
        // search and again on scroll repaint. Note: a legitimate "no results"
        // frame is still accepted — those carry `isFinal: true` so the user
        // sees the empty-results state on purpose. Preload (filter-1) is also
        // safe because it lists the 9 renters with `quantity: 0` — the arrays
        // are NOT empty, the items just have zero counts.
        const isEmptyHeartbeat = renters.length === 0 &&
            cars.length === 0 &&
            rates.length === 0 &&
            engines.length === 0 &&
            payload.isFinal !== true;
        if (isEmptyHeartbeat) {
            return;
        }
        const allPrices = [...renters, ...cars, ...rates, ...engines].map((item) => item.price);
        // Process renters, cars, and extra filters
        const processRentersResult = mergeRentersWithImages(processFiltersRenters(renters), carRenters);
        const tMap = translationMapRef.current;
        const lang = i18next.language.toUpperCase();
        const needsTranslation = lang !== "EN" && !lang.startsWith("EN");
        const processCategoriesResult = cars.map((car) => {
            var _a, _b, _c;
            let name = car.name;
            const match = tMap.get(car.value);
            if (match) {
                name = ((_a = match.translations.find((t) => lang.includes(t.language.toUpperCase()))) === null || _a === void 0 ? void 0 : _a.text) || match.name;
            }
            else if (needsTranslation) {
                const cached = resultFilters.categories.find((c) => c.value === car.value);
                if ((cached === null || cached === void 0 ? void 0 : cached.name) && cached.name !== car.name)
                    name = cached.name;
            }
            return { ...car, name, loadingData: (_b = car.loadingData) !== null && _b !== void 0 ? _b : true, price: (_c = car.price) !== null && _c !== void 0 ? _c : 0 };
        });
        const processExtraCars = proccessExtraFilters([...rates, ...engines]);
        const _resultFilters = {
            renters: processRentersResult,
            categories: processCategoriesResult,
            extras: processExtraCars,
        };
        localStorage.setItem(keyLocalStorageResultFilters, JSON.stringify(_resultFilters, (_, value) => {
            if (value instanceof HTMLElement || React.isValidElement(value)) {
                return undefined; // or you can return a string like '[Circular]'
            }
            return value;
        }));
        setResultFilters(_resultFilters);
        // Update the minimum price based on the allPrices array
        updateMinimumPrice(allPrices);
        setShowFilters(true);
    };
    /**
     * Main function to process the filters data, including renters, cars, rates, and engines.
     * It updates the local storage and session storage with the filtered results.
     */
    const [resultFilters, setResultFilters] = useState(() => {
        const _resultFilters = localStorage.getItem(keyLocalStorageResultFilters);
        const { renters = [], categories = [], extras = [] } = JSON.parse(_resultFilters !== null && _resultFilters !== void 0 ? _resultFilters : "{}");
        return {
            categories: categories.map((car) => ({
                ...car,
                loadingData: true,
                price: null,
            })),
            extras: [],
            renters: renters.map((renter) => ({
                ...renter,
                loadingData: true,
                price: null,
            })),
        };
    });
    const mergedRenters = mergeRentersWithImages(resultFilters.renters, carRenters);
    /**
     * Ensures ALL default renters are always present in the filter bar.
     * Live data from mergedRenters overwrites the defaults, but renters
     * missing from the live data keep their default (loading) state.
     * This prevents renters from disappearing when processFiltersRenters
     * produces a partial list due to collectionMock matching gaps.
     */
    const allRenters = useMemo(() => {
        if (mergedRenters.length === 0)
            return defaultRenters;
        return defaultRenters.map((def) => {
            const live = mergedRenters.find((r) => r.value === def.value);
            return live || def;
        });
    }, [mergedRenters]);
    /**
     * Handles changes to the filter state.
     * Updates the filters only if the application status is `RUNNIG`.
     *
     * @param filters - The new filter values to be applied.
     */
    const onHandleFilterChange = (filters) => {
        if (statusApp === Status_App.RUNNIG)
            setFilters(filters);
    };
    return (_jsxs("div", { id: "main_div_search_results", className: loading ? "loading-results" : "uploaded-results", children: [Object.values(resultFilters).flat().length > 0 && (_jsx(_Fragment, { children: _jsx(CarCategories, { currency: currency !== null && currency !== void 0 ? currency : "", categories: resultFilters.categories, renters: allRenters, extraFilters: resultFilters.extras, rate: rate !== null && rate !== void 0 ? rate : "", totalDays: totalDays, setData: setData, filters: filters, setFilters: onHandleFilterChange, noResultstate: noResultstate, showFilters: showFilters, t: t, setLoading: setLoading, shouldBeSelectedfilters: shouldBeSelectedfilters, categoryTranslations: categoryTranslations, setSortBy: setSortBy, setSortOrder: setSortOrder, sortOrder: sortOrder, isSearchCompleted: isCompleted, isFinal: isFinal, isComplete: isComplete, collections: collections }) })), _jsxs("div", { className: "container-results", children: [_jsx(MapModalLocations, { applyFilters: onHandleFilterChange, filters: filters, locationsResults: locationsResults, customClass: "map-locations-aviability" }), loading ? (_jsx(_Fragment, { children: noResultstate || noResultstateFilters ? (_jsx(NoResultsBanner, { type: noResultstateFilters ? "filters" : "search" })) : (_jsx(ProfitLoading, {})) })) : (_jsxs("div", { style: { display: "block" }, children: [showFilters && (_jsx(AvailabilityList, { data: data, collections: collections, totalDays: totalDays, currency: currency !== null && currency !== void 0 ? currency : "", rate: rate !== null && rate !== void 0 ? rate : "", idSession: idSession !== null && idSession !== void 0 ? idSession : "", transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : "", userId: userId !== null && userId !== void 0 ? userId : "", pickUpDate: formatDateToDdMmYyyy(pickUpDate), DropOffDate: formatDateToDdMmYyyy(DropOffDate), pickUpTime: pickUpTime !== null && pickUpTime !== void 0 ? pickUpTime : "", DropOffTime: DropOffTime !== null && DropOffTime !== void 0 ? DropOffTime : "", pickupLocationCode: pickupLocationCode !== null && pickupLocationCode !== void 0 ? pickupLocationCode : "", returnLocationCode: returnLocationCode !== null && returnLocationCode !== void 0 ? returnLocationCode : "", carCategories: carCategories, landingid: landingid, userAnalyser: userAnalizer, applyDiscount: applyDiscount, bannersData: bannersData, filters: filters, pageNumber: pageNumber, finalized: finalized, t: t, resultFiltersCategories: categoryTranslations, showFilters: showFilters, searchId: (_j = sessionStorage.getItem("searchId")) !== null && _j !== void 0 ? _j : "", ip: ip, userUFP: userUFP, loading: loading, locationsResults: locationsResults })), showFilters && (_jsxs("div", { className: "collection-more", children: [_jsx("button", { className: "hide-desktop button button-primary button--rounded " + (showMoreButton ? "" : "hidden"), onClick: () => {
                                            const nextPage = pageNumber + 1;
                                            currenType.current = "paginate";
                                            setPageNumber(nextPage);
                                            currentPage.current = nextPage;
                                            getData(nextPage, 30, ip, "paginate");
                                        }, children: t("btn_look-more-results") }), _jsx("button", { className: "hide-mobile button--rounded button-outline--black " + (showMoreButton ? "" : "hidden"), onClick: () => {
                                            const nextPage = pageNumber + 1;
                                            currenType.current = "paginate";
                                            currentPage.current = nextPage;
                                            setPageNumber(nextPage);
                                            getData(nextPage, 30, ip, "paginate");
                                        }, children: t("btn_look-more-results") })] }))] }, "honkkong"))] })] }));
};
export default SearchResults;
